// extracted by mini-css-extract-plugin
export default {"custom_select":"styles_custom_select__ky9cn"};